import styled from 'styled-components';

import {
  Container as SliderContainer,
  PercentageBar as SliderPercentageBar,
  ValueButton as SliderValueButton
} from '@spa/shared/components/Slider/styles';
import { mediaMin, tabletRange } from '@spa/shared/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${props => props.theme.gap(20, 'column')};
  height: 35cqw;
  width: 100%;

  .lty-playbtn {
    visibility: hidden;
  }

  [data-ntpc='YouTubeEmbed'],
  iframe {
    width: 100% !important;
    height: 100% !important;
  }

  ${tabletRange.ipad()`
    height: 45vh;
    min-height: min-content;
  `}

  ${mediaMin.mediumBreakpoint`
    ${props => props.theme.gap(15, 'column')};
  `}

  ${mediaMin.extraSmallBreakpoint`
    min-height: 50%;
    ${props => props.theme.gap(10, 'column')};
  `};
`;

export const ControlsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
  ${props => props.theme.gap(2.5, 'column')};

  ${mediaMin.mediumBreakpoint`
    width: 75%;
  `};

  ${mediaMin.extraSmallBreakpoint`
    width: 100%;
  `};

  ${SliderContainer} {
    cursor: pointer;
    background-color: transparent;
    min-height: 11px;
    border: 1px solid ${props => props.theme.youtubePlayer.progressionBar.borderColor};
  }

  ${SliderPercentageBar} {
    top: 0;
    min-height: 9px;
    border-radius: 12px;
  }

  ${SliderValueButton} {
    visibility: hidden;
  }
`;

export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${props => props.theme.gap(2.5)};

  button {
    min-width: 15px;
    height: 15px;
    padding-inline: 0;

    svg {
      width: 15px;
      height: 15px;
    }

    &:nth-of-type(2) {
      svg {
        width: 27px;
      }
    }
  }

  span {
    font-weight: 600;
  }
`;

export const ControlButtons = styled.div`
  display: flex;
  ${props => props.theme.gap(2.5)};
`;
